module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.hit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.reset($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update],
      "blur": _vm.onBlur,
      "focus": _vm.onFocus
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems && _vm.focus),
      expression: "hasItems && focus"
    }]
  }, _vm._l((_vm.items), function(item, $item) {
    return _c('li', {
      class: _vm.activeClass($item),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          _vm.setActive($item)
        }
      }
    }, [_c('span', {
      staticClass: "screen-name",
      domProps: {
        "textContent": _vm._s(item)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a804e91c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typeahead.vue
// module id = 285
// module chunks = 1